import * as Yup from 'yup'
import {
  AsyncCarModel,
  AsyncCustomerModel,
  AsyncReservationSourceModel,
  AsyncVehicleGroupModel,
  BaseEntity,
} from '../../../shared/models/ApiModels'
import {SubTabOption} from '../../../shared/components/SubTabHeader'
import {additionalList, DriverModel, IAdditionalServiceModel} from '../reservation/ReservationModel'

const getCurrentTime = () => {
  const now = new Date()
  const hours = now.getHours().toString().padStart(2, '0')
  const minutes = now.getMinutes().toString().padStart(2, '0')
  return `${hours}:${minutes}`
}

export interface IRentModel extends BaseEntity {
  // Hızlı Giriş
  customer: AsyncCustomerModel | null
  customerId: string
  customerFullName: string
  status: string
  rentDate: Date
  documentNo: string
  agreementNo: string
  flightNumber: string
  startDate: Date
  startTime: string
  endDate: Date
  endTime: string
  rentalDay: number
  pickupBranch: string
  pickupBranchId: string
  pickupBranchName: string
  pickupBranchNote: string
  returnBranch: string
  returnBranchId: string
  returnBranchName: string
  returnBranchNote: string
  rentalType: string
  billingType: string
  customerCompany: AsyncCustomerModel | null
  customerCompanyId: string
  customerCompanyName: string
  calculationType: string
  currency: string
  price: number
  discount: number
  priceAfterDiscount: number
  vehicleGroupId: string
  vehicleGroupName: string
  reservationSource: AsyncReservationSourceModel | null
  reservationSourceId: string
  reservationSourceName: string
  deliveredPersonelId: string
  car: AsyncCarModel | null
  carId: string
  carPlate: string
  brandName: string
  modelType: string
  transmission: string
  fuelType: string
  rentalAmount: string
  additionalServiceAmount: string
  subTotalAmount: string
  taxAmount: string
  totalAmount: number
  generalTotalWithCurrency: string
  remainingAmount: string
  remainingCurrency: string
  outKM: number
  outFuelLevel: string

  // Rez.Bilgisi / Teslimat
  startDateDetail: Date
  startTimeDetail: string
  endDateDetail: Date
  endTimeDetail: string
  rentalDayDetail: number
  reservedPersonelId: string
  optionType: string
  optionDay: number
  optionDate: string
  giftDay: string 
  billPeriod: Date | null
  billPeriodType: string
  billProfile: string

  // Müşteri Bilgileri
  phone: string
  email: string
  driverLicenseNo: string
  tcIdentityNo: string
  reservationSourceDetail: AsyncReservationSourceModel | null
  secondReservationSource: AsyncReservationSourceModel | null
  secondReservationSourceId: string

  // Araç
  vehicleGroupNameDetail: string
  deliveredVehicleGroup: AsyncVehicleGroupModel | null
  carDetail: AsyncCarModel | null
  carInfo: string
  modelTypeDetail: string
  transmissionDetail: string
  brandNameDetail: string
  modelYear: string
  fuelTypeDetail: string
  fullness: string
  carLocation: string
  outKmDetail: number
  outFuelLevelDetail: string

  // Fiyat / Toplam
  pricingType: string
  price1: number
  discount1: number
  priceAfterDiscount1: number
  currency1: string
  autoDescription: string
  deliveryType: string
  tariffId: string
  campaign: string
  campaignCondition: string
  customVatRate: string
  promotionCode: string
  promotionAmount: number
  promotionCurrency: string
  rentAmount1: string
  serviceAmount1: string
  kdvTl1: string
  totalAmount1: string
  grandTotal: string
  collection: string
  remaining1: string
  remainingCurrency1: string
  hourDifferenceTaken: boolean
  paymentMethod: string

  //Additional Services
  customerAdd: string
  pickupBranchAdd: string
  returnBranchAdd: string
  priceAdd: number
  generalCurrencyAdd: string
  startDateAdd: Date
  startTimeAdd: string
  rentDayAdd: number
  plateAdd: string
  calculationTypeAdd: string
  endDateAdd: Date
  endTimeAdd: string
  vehicleGroupAdd: string
  totalAmountAdd: number
  remainingAmountAdd: string
  currencyAdd: string
  additionalCurrencyAdd: string
  additionalServiceSellOwner: string
  additionalServices: IAdditionalServiceModel[] | null

  // Ayrıntılar
  explanation: string
  warningDescription: string
  billDescription: string
  notes: IRentNoteModel[] | null

  // Account & flight info
  accountOwner: string
  accountNo: string
  accountDate: Date | null
  security: string
  provisionNo: string
  provisionAmount: number
  provisionDate: Date | null

  // Drivers
  driverFirst: DriverModel
  driverSecond: DriverModel

  // Other Info
  manualFindexScore: string
  guarantor: string
  customerVehicle: string
  vehicleDetails: string
  specialCode: string
  requestType: string
  companyCode: string
  requestSourceUnit: string
  approvalCode: string
  projectName: string
  riskPermissionLevel: string
  specialDriverInfo: string
  specialDriverCode: string
  noShowBillList: boolean
  kabisOut: boolean
  automaticExtending: boolean
  kabisReturn: boolean

  // Accessory
  spareKeyBefore: boolean
  spareKeyAfter: boolean
  spareTireBefore: boolean
  spareTireAfter: boolean
  chainBefore: boolean
  chainAfter: boolean
  firstAidBagBefore: boolean
  firstAidBagAfter: boolean
  frontLeftTireBefore: string
  frontLeftTireAfter: string
  frontRightTireBefore: string
  frontRightTireAfter: string
  backLeftTireBefore: string
  backLeftTireAfter: string
  backRightTireBefore: string
  backRightTireAfter: string

  //return
  customerReturn: string
  pickupBranchReturn: string
  returnBranchReturn: string
  priceReturn: number
  generalCurrencyReturn: string
  startDateReturn: Date
  startTimeReturn: string
  endDateReturn: Date
  endTimeReturn: string
  rentDayReturn: number
  plateReturn: string
  calculationTypeReturn: string
  vehicleGroupReturn: string
  totalAmountReturn: number
  remainingAmountReturn: string
  currencyReturn: string
  statusReturn: string
  outKMReturn: number
  outFuelLevelReturn: string
  returnDateText: string
  returnTimeText: string
  inKM: number
  usedKM: number
  recipientPersonelId: string
  overKmManuel: boolean
  dailyKmLimit: number
  totalKmLimit: number
  differenceKM: number
  deliveryTypeReturn: string
  overKmFeeManuel: boolean
  dailyOverKmFee: number
  totalOverKmFee: number
  returnReason: string
  inFuelLevel: string
}

export const initialRent: IRentModel = {
  // Hızlı Giriş
  customer: null,
  customerId: '',
  customerFullName: '',
  status: '0',
  rentDate: new Date(),
  documentNo: '',
  agreementNo: '',
  flightNumber: '',
  startDate: new Date(),
  startTime: getCurrentTime(),
  endDate: (() => {
    const d = new Date()
    d.setDate(d.getDate() + 1)
    return d
  })(),
  endTime: getCurrentTime(),
  rentalDay: 1,
  pickupBranch: '',
  pickupBranchId: '',
  pickupBranchName: '',
  pickupBranchNote: '',
  returnBranch: '',
  returnBranchId: '',
  returnBranchName: '',
  returnBranchNote: '',
  rentalType: '0',
  billingType: '0',
  customerCompany: null,
  customerCompanyId: '',
  customerCompanyName: '',
  calculationType: '1',
  currency: 'a6bb38bf-b3d2-4d78-bf73-f5e602600f9b',
  price: 0,
  discount: 0,
  priceAfterDiscount: 0,
  vehicleGroupId: '',
  vehicleGroupName: '',
  car: null,
  carId: '',
  carPlate: '',
  reservationSource: null,
  reservationSourceId: '',
  reservationSourceName: '',
  deliveredPersonelId: '',
  brandName: '',
  modelType: '',
  transmission: '',
  fuelType: '',
  rentalAmount: '',
  additionalServiceAmount: '',
  subTotalAmount: '',
  taxAmount: '',
  totalAmount: 0,
  generalTotalWithCurrency: 'a6bb38bf-b3d2-4d78-bf73-f5e602600f9b',
  remainingAmount: '0',
  remainingCurrency: 'a6bb38bf-b3d2-4d78-bf73-f5e602600f9b',
  outKM: 0,
  outFuelLevel: '',

  // Kira Bilgisi / Teslimat
  startDateDetail: new Date(),
  startTimeDetail: getCurrentTime(),
  endDateDetail: (() => {
    const d = new Date()
    d.setDate(d.getDate() + 1)
    return d
  })(),
  endTimeDetail: getCurrentTime(),
  reservedPersonelId: '',
  optionType: '',
  optionDay: 0,
  optionDate: '',
  giftDay: '',
  rentalDayDetail: 1,
  billPeriod: null,
  billPeriodType: '',
  billProfile: '',

  // Müşteri Bilgileri
  phone: '',
  email: '',
  driverLicenseNo: '',
  tcIdentityNo: '',
  reservationSourceDetail: null,
  secondReservationSource: null,
  secondReservationSourceId: '',

  // Araç / Grup
  vehicleGroupNameDetail: '',
  deliveredVehicleGroup: null,
  carDetail: null,
  brandNameDetail: '',
  modelTypeDetail: '',
  transmissionDetail: '',
  fuelTypeDetail: '',
  carInfo: '',
  modelYear: '',
  fullness: '',
  carLocation: '',
  outKmDetail: 0,
  outFuelLevelDetail: '',

  // Fiyat / Toplam
  pricingType: '1',
  price1: 0,
  discount1: 0,
  priceAfterDiscount1: 0,
  currency1: 'a6bb38bf-b3d2-4d78-bf73-f5e602600f9b',
  autoDescription: '',
  deliveryType: '0',
  tariffId: '',
  campaign: '',
  campaignCondition: '',
  promotionCode: '',
  promotionAmount: 0,
  promotionCurrency: '0',
  customVatRate: '',
  rentAmount1: '',
  serviceAmount1: '',
  kdvTl1: '',
  totalAmount1: '',
  grandTotal: '',
  collection: '0',
  remaining1: '',
  remainingCurrency1: 'a6bb38bf-b3d2-4d78-bf73-f5e602600f9b',
  hourDifferenceTaken: true,
  paymentMethod: '0',

  //Additional Services
  customerAdd: '',
  pickupBranchAdd: '',
  returnBranchAdd: '',
  priceAdd: 0,
  generalCurrencyAdd: 'TL',
  startDateAdd: new Date(),
  startTimeAdd: getCurrentTime(),
  rentDayAdd: 0,
  plateAdd: '',
  calculationTypeAdd: 'KDV Günlük Dahil',
  endDateAdd: (() => {
    const d = new Date()
    d.setDate(d.getDate() + 1)
    return d
  })(),
  endTimeAdd: getCurrentTime(),
  vehicleGroupAdd: '',
  totalAmountAdd: 0,
  remainingAmountAdd: '0',
  currencyAdd: 'TL',
  additionalCurrencyAdd: 'a6bb38bf-b3d2-4d78-bf73-f5e602600f9b',
  additionalServiceSellOwner: '',
  additionalServices: additionalList.map((service) => ({
    name: service.name,
    isAdd: false,
    title: service.title,
    isDaily: service.isDaily,
    hasPiece: service.hasPiece,
    piece: 0,
    price: 0,
    hasProduct: service.hasProduct,
    productNumber: '',
    productOwner: '0',
    totalPrice: 0,
    hasStatus: true,
    status: '0',
  })),

  // Ayrıntılar
  explanation: '',
  warningDescription: '',
  billDescription: '',
  notes: null,

  // Finance/Flight Info
  accountOwner: '',
  accountNo: '',
  accountDate: null,
  security: '',
  provisionNo: '',
  provisionAmount: 0,
  provisionDate: null,

  //Driver Info
  driverFirst: {
    driver: null,
    fullName: '',
    phone: '',
    tckn: '',
    licenseNo: '',
    name: '',
    surname: '',
    licensePlace: '',
    licenseDate: null,
    birthDate: null,
  },

  driverSecond: {
    driver: null,
    fullName: '',
    phone: '',
    tckn: '',
    licenseNo: '',
    name: '',
    surname: '',
    licensePlace: '',
    licenseDate: null,
    birthDate: null,
  },

  //Other Info
  manualFindexScore: '',
  guarantor: '',
  customerVehicle: '',
  vehicleDetails: '',
  specialCode: '',
  requestType: '',
  companyCode: '',
  requestSourceUnit: '',
  approvalCode: '',
  projectName: '',
  riskPermissionLevel: '0',
  specialDriverInfo: '',
  specialDriverCode: '',
  noShowBillList: false,
  kabisOut: false,
  automaticExtending: false,
  kabisReturn: false,

  // Accessory
  spareKeyBefore: false,
  spareKeyAfter: false,
  spareTireBefore: false,
  spareTireAfter: false,
  chainBefore: false,
  chainAfter: false,
  firstAidBagBefore: false,
  firstAidBagAfter: false, 
  frontLeftTireBefore: '',
  frontLeftTireAfter: '',
  frontRightTireBefore: '',
  frontRightTireAfter: '',
  backLeftTireBefore: '',
  backLeftTireAfter: '',
  backRightTireBefore: '',
  backRightTireAfter: '',

  // Return 
  customerReturn: '',
  pickupBranchReturn: '',
  returnBranchReturn: '',
  priceReturn: 0,
  generalCurrencyReturn: 'TL',
  startDateReturn: new Date(),
  startTimeReturn: getCurrentTime(),
  endDateReturn: (() => {
    const d = new Date()
    d.setDate(d.getDate() + 1)
    return d
  })(),
  endTimeReturn: getCurrentTime(),
  rentDayReturn: 1,
  plateReturn: '',
  calculationTypeReturn: 'KDV Günlük Dahil',
  vehicleGroupReturn: '',
  totalAmountReturn: 0,
  remainingAmountReturn: '0',
  currencyReturn: 'TL',
  statusReturn: '0',
  outKMReturn: 0,
  outFuelLevelReturn: '',
  returnDateText: '',
  returnTimeText: '',
  recipientPersonelId: '',
  dailyKmLimit: 0,
  totalKmLimit: 0,
  deliveryTypeReturn: '0',
  inKM: 0,
  usedKM: 0,
  overKmManuel: false,
  differenceKM: 0,
  overKmFeeManuel: false,
  dailyOverKmFee: 0,
  totalOverKmFee: 0, 
  returnReason: '',
  inFuelLevel: ''
}

export const validationRent = Yup.object().shape({
  //customer: Yup.string().nullable().required('Cari bilgisi zorunludur'),
  // Tarihler ve saatler
  startDate: Yup.date().required('Başlangıç tarihi zorunludur'),
  startTime: Yup.string().required('Başlangıç saati zorunludur'),
  endDate: Yup.date().required('Beklenen tarih zorunludur'),
  endTime: Yup.string().required('Beklenen saat zorunludur'),

  // Ofis seçimleri
  //pickupBranchId: Yup.string().required('Çıkış ofisi zorunludur'),
  //returnBranchId: Yup.string().required('Dönüş ofisi zorunludur'),
  //vehicleGroup: Yup.string().nullable().required('Araç grubu zorunludur'),

  // Durum & Tarih
  status: Yup.string().required('Rezervasyon durumu zorunludur'),
  //rentDate: Yup.string().required('Rezervasyon Tarihi zorunludur'),
  //rentalType: Yup.string().required('Kiralama Türü zorunludur'),
  //paymentType: Yup.string().required('Ödeme Türü zorunludur'),
  //calculationType: Yup.string().required('Hesaplama Tipi zorunludur'),
  //currency: Yup.string().required('Döviz Bilgisi zorunludur'),

  // Fiyat bilgileri
  price: Yup.number()
    .typeError('Fiyat sayı olmalıdır')
    .required('Fiyat zorunludur')
    .min(0, 'Negatif olamaz'),
  discount: Yup.number().typeError('İndirim sayı olmalıdır').min(0, 'Negatif olamaz'),
  //remaining: Yup.number().typeError('Kalan tutar sayı olmalıdır').min(0, 'Negatif olamaz'),
})

export interface IRentFilterModel {
  customerId: string | null
  reservationNo: string | null
  carId: string | null
  status: string | null
  dateFilterType: number | null
  startDate: Date | null
  endDate: Date | null
  customerCompanyId: string | null
  vehicleGroupId: string | null
  officeFilterType: number | null
  officeIdList: string[] // boş array gönderilebilir
  /** Kira listesi — plaka arama modu */
  plateSearchMode: string | null
  plateText: string | null
  fileNo: string | null
  rentListStatus: string | null
  invoiceStatus: string | null
  summaryInfo: string | null
  racTabletUsage: string | null
  documentStatus: string | null
  rentalTypeFilter: string | null
  personnelFilterType: string | null
  personnelId: string | null
  balanceFilter: string | null
  reservationSourceIdList: string[]
  vehicleGroupIdList: string[]
  cardFirst4: string | null
  cardLast4: string | null
}

export const initialRentFilter: IRentFilterModel = {
  customerId: null,
  reservationNo: null,
  carId: null,
  status: null,
  dateFilterType: null,
  startDate: new Date(),
  endDate: (() => {
    const d = new Date()
    d.setDate(d.getDate() + 365)
    return d
  })(),
  customerCompanyId: null,
  vehicleGroupId: null,
  officeFilterType: null,
  officeIdList: [],
  plateSearchMode: '0',
  plateText: null,
  fileNo: null,
  rentListStatus: null,
  invoiceStatus: null,
  summaryInfo: null,
  racTabletUsage: '0',
  documentStatus: null,
  rentalTypeFilter: null,
  personnelFilterType: null,
  personnelId: null,
  balanceFilter: '0',
  reservationSourceIdList: [],
  vehicleGroupIdList: [],
  cardFirst4: null,
  cardLast4: null,
}

export interface IRentNoteModel {
  note: string | null
}

export const validationRentFilter = Yup.object().shape({})

export const rentSubTabOptions: SubTabOption<
  'desc' | 'flight' | 'drivers' | 'other' | 'accessory'
>[] = [
  {key: 'desc', title: 'Açıklama', icon: 'bi bi-card-text'},
  {key: 'flight', title: 'Finans/Uçuş', icon: 'bi bi-clipboard-data'},
  {key: 'drivers', title: 'Sürücüler', icon: 'bi bi-speedometer2'},
  {key: 'other', title: 'Diğer Bilgiler', icon: 'bi bi-tools'},
  {key: 'accessory', title: 'Aksesuar', icon: 'bi bi-cash-stack'},
]
